const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

const flattenLeafKeys = (value, prefix = '') => {
  if (!isPlainObject(value)) return prefix ? [prefix] : []

  return Object.entries(value).flatMap(([key, child]) => {
    const keyPath = prefix ? `${prefix}.${key}` : key
    return isPlainObject(child) ? flattenLeafKeys(child, keyPath) : [keyPath]
  })
}

export const mergeConflicts = new Map()

export const deepMerge = (target, source, { scope, keyPath = '' } = {}) => {
  const result = { ...target }

  Object.entries(source).forEach(([key, next]) => {
    const currentKeyPath = keyPath ? `${keyPath}.${key}` : key
    const prev = result[key]

    // 沒有這個 key
    if (prev === undefined) {
      result[key] = isPlainObject(next)
        ? deepMerge({}, next, { scope, keyPath: currentKeyPath })
        : next
      return
    }

    // object 合併
    if (isPlainObject(prev) && isPlainObject(next)) {
      result[key] = deepMerge(prev, next, { scope, keyPath: currentKeyPath })
      return
    }

    // 覆蓋
    if (!isPlainObject(prev) && !isPlainObject(next) && typeof prev === typeof next) {
      result[key] = next
      return
    }

    const failedKeys = isPlainObject(next)
      ? flattenLeafKeys(next, currentKeyPath)
      : [currentKeyPath]

    failedKeys.forEach((leaf) => {
      mergeConflicts.set(`${scope}::${leaf}`, { reason: 'value 型別有衝突' })
    })
  })

  return result
}
